/**
 * @generated SignedSource<<12cbb1d79e447513fd673c00bfe7f086>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "componentStatus"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RosterLoadMutationGroup",
    "kind": "LinkedField",
    "name": "rosterLoad",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "componentStatus",
                "variableName": "componentStatus"
              },
              {
                "kind": "Variable",
                "name": "rosterLoadId",
                "variableName": "id"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "RosterLoadAutoAcceptComponentsPayload",
        "kind": "LinkedField",
        "name": "autoAcceptComponents",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unmodifiedCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "acceptedCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "acceptedComponentIds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InProgressRosterLoadAutoAcceptMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "InProgressRosterLoadAutoAcceptMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "517ae420f8e75d0574302d772cb65f23",
    "id": null,
    "metadata": {},
    "name": "InProgressRosterLoadAutoAcceptMutation",
    "operationKind": "mutation",
    "text": "mutation InProgressRosterLoadAutoAcceptMutation(\n  $id: ID!\n  $componentStatus: RosterLoadAutoAcceptComponentStatus!\n) {\n  rosterLoad {\n    autoAcceptComponents(input: {rosterLoadId: $id, componentStatus: $componentStatus}) {\n      unmodifiedCount\n      acceptedCount\n      acceptedComponentIds\n    }\n  }\n}\n"
  }
};
})();

node.hash = "db7f4d9a0321f9d29effc2d2415b6f7f";

export default node;
